import React from 'react';
import xLogo from '../../Assets/images/xLogo.png';
import linkLogo from '../../Assets/images/linkd.png';
import instaLogo from '../../Assets/images/insta.png';
import metaLogo from '../../Assets/images/meta.png';
import youtubeLogo from '../../Assets/images/youtube.png';

export const Footer = () => {
    return (
        <div className="speakers-background">
            <div className='indiaJoy__footer__container'>
                <div className="footer-title">
                    INDIAJOY 2024
                </div>
                <div className="subscribe-content">
                    <div className="subscribe">
                        <input type="email" className='emailInput form-control' placeholder='Enter your Email' />
                    </div>
                    <div className="subscribe">
                        <button className="subscribe-button btn">SUBSCRIBE</button>
                    </div>
                </div>
                <div className='address-content'>
                    IMAGE Incubation – Office 1, DivyaShree Building, Inorbit Mall Rd, HITEC City, Hyderabad-500081,Telangana,India.
                </div>
                <div className='indiaJoy__rightPanel__container__footer'>
                    <div className='indiaJoy__rightPanel__footer'>
                        <div className='indiaJoy__rightPanel__section'>
                            <a href="https://twitter.com/indiajoyin?lang=en" target="_blank" rel="noopener noreferrer">
                                <img src={xLogo} alt='xLogo' />
                            </a>
                        </div>
                        <div className='indiaJoy__rightPanel__section'>
                            <a href="https://www.linkedin.com/company/indiajoy/" target="_blank" rel="noopener noreferrer">
                                <img src={linkLogo} alt='linkLogo' />
                            </a>
                        </div>
                        <div className='indiaJoy__rightPanel__section'>
                            <a href="https://www.instagram.com/indiajoyfestival/" target="_blank" rel="noopener noreferrer">
                                <img src={instaLogo} alt='instaLogo' />
                            </a>
                        </div>
                        <div className='indiaJoy__rightPanel__section'>
                            <a href="https://www.facebook.com/Indiajoy.in/" target="_blank" rel="noopener noreferrer">
                                <img src={metaLogo} alt='metaLogo' />
                            </a>
                        </div>
                        <div className='indiaJoy__rightPanel__section'>
                            <a href="https://www.youtube.com/channel/UCe8cEAMgMZbqS2cf8t4_JQg" target="_blank" rel="noopener noreferrer">
                                <img src={youtubeLogo} alt='youtubeLogo' />
                            </a>
                        </div>
                    </div>
                </div>
                <hr className='styled-hr' />
                <div className='footer-content'>
                    © Copyright ©2024 Indiajoy. All Rights Reserved
                </div>
            </div>
        </div>

    )
}
